import { EmailOutlined as MailIcon } from '@mui/icons-material';

const Mail = (): JSX.Element => <MailIcon fontSize="inherit" />;

export default Mail;
